//
//
//
//
//

import ComGetDetail from "@/components/_comForm/04.comGetDetail";
export default {
  components: {
    "com-get-detail": ComGetDetail
  },
  data() {
    return {
      pageConfig: {
        api: "/MisAdminApi/PassageUserGoodsBuyOrder/",
        GetDetailForm: "GetDetailFormM"
      }
    };
  },
  created() {},

  methods: {
    Change() {
      this.btnConfig = {
        list: [
          { text: "返回", type: "warn", action: () => this.$router.go(-1) }
        ]
      };
    },
    async startWechatPay() {
      // var wechatOpenId = this.$route.query.wechatOpenId;
      var OrderOpenId = this.$route.query.openId;
      // var OrderOpenId = resultData.orderOpenId.OrderOpenId;
      // if (!wechatOpenId) {
      //   this.$msg.alert("wechatOpenId参数不能为空.");
      //   return;
      // }
      // var url = "/mWechatApi/WechatPay/Pay";
      var url = "/mWechatApi/WechatPay/GetPayData";
      this.$msg.showLoading("正在支付...");
      var postData = {
        orderType: "99",
        orderOpenId: OrderOpenId
      };

      let { data: result } = await this.$http({
        method: "post",
        url: url,
        data: postData
      });
      this.$msg.hideLoading();
      console.log("WechatPay/Pay---result", result);

      if (result.state == 1) {
        this._createWechatPay(result);
        return;
      }
      this.$msg.alert(result.msg);
      console.log(result);
    },

    //微信支付
    _createWechatPay(result) {
      var data = result.data.PayData;
      var payData = {
        appId: data.AppId, //公众号名称，由商户传入
        timeStamp: data.Timestamp,
        nonceStr: data.NonceStr,
        package: data.Package,
        signType: data.SignType,
        paySign: data.PaySign //微信签名
      };
      WeixinJSBridge.invoke("getBrandWCPayRequest", payData, res => {
        console.log("getBrandWCPayRequest", res);
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          //支付成功
          //window.location.href = result.successUrl;
          // this.$msg.alert(result.successUrl);
          this.$refs.mychild.initForm()
          // this.$router.push(
          //   "/Mis/ShopUserGoodsActivityBuyOrder/End?OpenId=" +
          //     resultData.orderOpenId.OrderOpenId +
          //     "&OrderNo=" +
          //     resultData.orderOpenId.OrderNo +
          //     "&OrderOn=" +
          //     resultData.orderOpenId.OrderOn +
          //     "&OrderBy=" +
          //     resultData.orderOpenId.OrderBy
          // );
          return;
        } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
          // 支付过程中用户取消

          this.$msg.alert("亲,您没有给我买单哦！", function() {});
          return;
        }
        this.$msg.alert(res.err_msg);
      });
    }
  }
};
